export default __webpack_public_path__ + "static/media/Empty_yourtaskfortheday.c968f356.svg";